import type { SVGProps } from 'react'
const WaterElectroConductivity = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' {...props}>
    <path d='M480-80q-137 0-228.5-94T160-408q0-62 28-124t70-119q42-57 91-107t91-87q8-8 18.5-11.5T480-860q11 0 21.5 3.5T520-845q42 37 91 87t91 107q42 57 70 119t28 124q0 140-91.5 234T480-80Zm-40-320v154q0 15 14.5 19t22.5-8l142-214q7-10 1.5-20.5T603-480h-83v-154q0-15-14.5-19t-22.5 8L341-431q-7 10-1.5 20.5T357-400h83Z' />
  </svg>
)
export default WaterElectroConductivity
